(function () {
  'use strict';

  if (window.PMSWhatsAppWidget) {
    window.PMSWhatsAppWidget.initAll();
    return;
  }

  var instances = new Map();
  var DIRECT_CLICKED_KEY = 'pms_whatsapp_direct_clicked';
  var AUTO_DISMISSED_KEY = 'pms_whatsapp_auto_dismissed';
  var NEXT_AUTO_KEY = 'pms_whatsapp_next_auto_at';

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function storageRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      return;
    }
  }

  function parseNumber(value, fallback) {
    var parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function init(root) {
    if (!root || root.dataset.pmsWhatsappInitialized === 'true') return;

    var launcher = root.querySelector('[data-pms-whatsapp-launcher]');
    var overlay = root.querySelector('[data-pms-whatsapp-overlay]');
    var dialog = root.querySelector('.pms-whatsapp-dialog');
    var closeButton = root.querySelector('[data-pms-whatsapp-close]');
    var form = root.querySelector('[data-pms-whatsapp-form]');
    var messageInput = root.querySelector('[data-pms-whatsapp-message]');
    var errorMessage = root.querySelector('[data-pms-whatsapp-error]');

    if (!launcher || !overlay || !dialog || !closeButton || !form) return;

    root.dataset.pmsWhatsappInitialized = 'true';

    var autoTimer = null;
    var openedAutomatically = false;
    var autoEnabled = root.dataset.autoOpen === 'true';
    var autoRepeat = root.dataset.autoRepeat === 'true';
    var designMode = root.dataset.designMode === 'true' ||
      Boolean(window.Shopify && window.Shopify.designMode);
    var initialDelay = Math.max(0, parseNumber(root.dataset.autoDelay, 10)) * 1000;
    var repeatDelay = Math.max(1, parseNumber(root.dataset.autoRepeatDelay, 30)) * 60000;

    function clearAutoTimer() {
      if (!autoTimer) return;
      window.clearTimeout(autoTimer);
      autoTimer = null;
    }

    function phoneNumber() {
      return String(root.dataset.phone || '').replace(/\D/g, '');
    }

    function messageUrl(message) {
      return 'https://wa.me/' + phoneNumber() + '?text=' + encodeURIComponent(message || '');
    }

    function focusableElements() {
      return Array.from(
        dialog.querySelectorAll('button:not([disabled]), textarea:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return element.offsetParent !== null;
      });
    }

    function canAutoOpen() {
      return autoEnabled &&
        !designMode &&
        !storageGet(DIRECT_CLICKED_KEY) &&
        !storageGet(AUTO_DISMISSED_KEY);
    }

    function scheduleAuto(delay) {
      clearAutoTimer();
      if (!canAutoOpen()) return;
      autoTimer = window.setTimeout(function () {
        autoTimer = null;
        if (document.visibilityState === 'hidden') {
          scheduleAuto(1000);
          return;
        }
        openDialog(true);
      }, Math.max(0, delay));
    }

    function scheduleRepeat() {
      if (!autoRepeat) {
        storageSet(AUTO_DISMISSED_KEY, '1');
        return;
      }

      var nextTime = Date.now() + repeatDelay;
      storageSet(NEXT_AUTO_KEY, String(nextTime));
      scheduleAuto(repeatDelay);
    }

    function openDialog(automatic) {
      if (overlay.open) return;
      openedAutomatically = Boolean(automatic);
      storageRemove(NEXT_AUTO_KEY);
      try {
        overlay.showModal();
      } catch (error) {
        overlay.setAttribute('open', '');
      }
      window.requestAnimationFrame(function () {
        overlay.classList.add('pms-whatsapp-overlay--open');
      });
      window.setTimeout(function () {
        if (messageInput) {
          messageInput.focus();
        } else {
          dialog.focus();
        }
      }, 0);
    }

    function closeDialog(allowRepeat) {
      if (!overlay.open) return;
      overlay.classList.remove('pms-whatsapp-overlay--open');
      try {
        overlay.close();
      } catch (error) {
        overlay.removeAttribute('open');
      }
      if (openedAutomatically && allowRepeat) scheduleRepeat();
      openedAutomatically = false;
      launcher.focus();
    }

    function markContactStarted() {
      clearAutoTimer();
      storageSet(DIRECT_CLICKED_KEY, '1');
      storageRemove(NEXT_AUTO_KEY);
      storageRemove(AUTO_DISMISSED_KEY);
    }

    function openWhatsApp(message, event) {
      var phone = phoneNumber();
      if (!phone) {
        if (event) event.preventDefault();
        errorMessage.textContent = 'Add a WhatsApp phone number in this section’s theme settings.';
        openDialog(false);
        return;
      }

      if (event) event.preventDefault();
      errorMessage.textContent = '';
      markContactStarted();
      closeDialog(false);

      var url = messageUrl(message);
      var isMobile = window.matchMedia('(max-width: 749px)').matches ||
        /Android|iPhone|iPad|iPod/i.test(window.navigator.userAgent);

      if (isMobile) {
        window.location.assign(url);
        return;
      }

      var newWindow = window.open(url, '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    }

    function handleLauncherClick(event) {
      openWhatsApp(root.dataset.defaultMessage || '', event);
    }

    function handleSubmit(event) {
      event.preventDefault();
      var typedMessage = messageInput ? messageInput.value.trim() : '';
      openWhatsApp(typedMessage || root.dataset.defaultMessage || '', event);
    }

    function handleCloseClick() {
      closeDialog(true);
    }

    function handleCancel(event) {
      event.preventDefault();
      closeDialog(true);
    }

    function handleOverlayClick(event) {
      if (event.target === overlay) closeDialog(true);
    }

    function handleKeydown(event) {
      if (!overlay.open || event.key !== 'Tab') return;

      var focusable = focusableElements();
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    launcher.addEventListener('click', handleLauncherClick);
    closeButton.addEventListener('click', handleCloseClick);
    form.addEventListener('submit', handleSubmit);
    overlay.addEventListener('cancel', handleCancel);
    overlay.addEventListener('click', handleOverlayClick);
    overlay.addEventListener('keydown', handleKeydown);

    if (canAutoOpen()) {
      var nextAuto = parseNumber(storageGet(NEXT_AUTO_KEY), 0);
      if (autoRepeat && nextAuto) {
        scheduleAuto(Math.max(0, nextAuto - Date.now()));
      } else {
        scheduleAuto(initialDelay);
      }
    }

    instances.set(root.dataset.sectionId, {
      destroy: function () {
        clearAutoTimer();
        launcher.removeEventListener('click', handleLauncherClick);
        closeButton.removeEventListener('click', handleCloseClick);
        form.removeEventListener('submit', handleSubmit);
        overlay.removeEventListener('cancel', handleCancel);
        overlay.removeEventListener('click', handleOverlayClick);
        overlay.removeEventListener('keydown', handleKeydown);
        if (overlay.open) {
          try {
            overlay.close();
          } catch (error) {
            overlay.removeAttribute('open');
          }
        }
        root.dataset.pmsWhatsappInitialized = 'false';
      }
    });
  }

  function syncLegacyWidgetVisibility() {
    document.documentElement.classList.toggle(
      'pms-whatsapp-custom-active',
      Boolean(document.querySelector('[data-pms-whatsapp-widget]'))
    );
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-pms-whatsapp-widget]')) init(context);
    context.querySelectorAll('[data-pms-whatsapp-widget]').forEach(init);
    syncLegacyWidgetVisibility();
  }

  function unload(sectionId) {
    var instance = instances.get(sectionId);
    if (!instance) return;
    instance.destroy();
    instances.delete(sectionId);
    window.setTimeout(syncLegacyWidgetVisibility, 0);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unload(event.detail.sectionId);
  });

  window.PMSWhatsAppWidget = {
    initAll: initAll,
    unload: unload
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    }, { once: true });
  } else {
    initAll();
  }
})();
